"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_i18next_1 = require("react-i18next");
var buy_home_icon_svg_1 = __importDefault(require("../../../images/buy-home-icon.svg"));
var rent_home_icon_svg_1 = __importDefault(require("../../../images/rent-home-icon.svg"));
var neighborhoods_home_icon_svg_1 = __importDefault(require("../../../images/neighborhoods-home-icon.svg"));
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var useActionForbidden_1 = require("../../hooks/useActionForbidden");
var react_router_dom_2 = require("react-router-dom");
var Routes_1 = require("../../constants/Routes");
var Localization_1 = require("../../constants/Localization");
var i18n_1 = __importDefault(require("../../i18n"));
var classnames_1 = __importDefault(require("classnames"));
var HelpSection = function () {
    var t = react_i18next_1.useTranslation('common').t;
    var history = react_router_dom_1.useHistory();
    var openAnnouncement = useActionForbidden_1.useActionForbidden(function () {
        history.push(Routes_1.Routes.Announcement.path);
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null,
            t('HOME.Help.Title'),
            " "),
        react_1.default.createElement("div", { className: 'help-card-container flex-middle' },
            react_1.default.createElement("div", { className: 'help-card' },
                react_1.default.createElement("span", { className: "help-card-image-section" },
                    react_1.default.createElement("img", { className: "help-card-image", src: buy_home_icon_svg_1.default, alt: "" })),
                react_1.default.createElement("h4", null, t('HOME.Help.Cards.first.Title')),
                react_1.default.createElement("p", null, t('HOME.Help.Cards.first.Description')),
                react_1.default.createElement(react_router_dom_2.Link, { to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].sell +
                        '?state=1', className: classnames_1.default('btn btn-primary', {
                        'help-card-search-button': i18n_1.default.language === Localization_1.Language.hy,
                    }) }, t('HOME.Help.Cards.first.Button'))),
            react_1.default.createElement("div", { className: 'help-card' },
                react_1.default.createElement("span", { className: "help-card-image-section" },
                    react_1.default.createElement("img", { className: "help-card-image", src: rent_home_icon_svg_1.default, alt: "" })),
                react_1.default.createElement("h4", null, t('HOME.Help.Cards.second.Title')),
                react_1.default.createElement("p", null, t('HOME.Help.Cards.second.Description')),
                react_1.default.createElement(react_router_dom_2.Link, { to: "/" + Localization_1.SellPagePrefix[i18n_1.default.language].rent +
                        '?state=1', className: classnames_1.default('btn btn-primary', {
                        'help-card-search-button': i18n_1.default.language === Localization_1.Language.hy,
                    }) }, t('HOME.Help.Cards.second.Button'))),
            react_1.default.createElement("div", { className: 'help-card' },
                react_1.default.createElement("span", { className: "help-card-image-section" },
                    react_1.default.createElement("img", { className: "help-card-image", src: neighborhoods_home_icon_svg_1.default, alt: "" })),
                react_1.default.createElement("h4", null, t('HOME.Help.Cards.three.Title')),
                react_1.default.createElement("p", null, t('HOME.Help.Cards.three.Description')),
                react_1.default.createElement("a", { onClick: openAnnouncement, className: 'btn btn-primary' }, t('HOME.Help.Cards.three.Button'))))));
};
exports.default = HelpSection;
